var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuestionBadge = function SvgQuestionBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 0c0 11.598-9.402 21-21 21V0h21z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0H0v19c10.493 0 19-8.507 19-19z",
    fill: "#0592AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.932 3.48c.181-.16.38-.312.596-.456a4.278 4.278 0 0 1 1.516-.628 4.65 4.65 0 0 1 .952-.092c.464 0 .887.064 1.268.192s.708.31.98.548c.272.237.483.524.632.86.15.336.224.712.224 1.128 0 .405-.059.756-.176 1.052a2.897 2.897 0 0 1-.444.772 3.529 3.529 0 0 1-.58.568l-.592.452c-.187.141-.348.28-.484.416a.821.821 0 0 0-.244.46L8.396 9.92H7.044l-.136-1.304a.356.356 0 0 1-.008-.068V8.48c0-.235.059-.439.176-.612.117-.173.264-.336.44-.488.176-.152.365-.3.568-.444.203-.144.392-.3.568-.468.176-.168.323-.359.44-.572a1.54 1.54 0 0 0 .176-.752c0-.192-.036-.364-.108-.516a1.167 1.167 0 0 0-.3-.392 1.345 1.345 0 0 0-.46-.252 1.849 1.849 0 0 0-.58-.088c-.304 0-.561.033-.772.1-.21.067-.39.141-.536.224a6.57 6.57 0 0 0-.372.224.511.511 0 0 1-.272.1.437.437 0 0 1-.416-.24l-.52-.824zm1.512 9.128c0-.165.03-.323.092-.472.061-.15.147-.277.256-.384a1.26 1.26 0 0 1 .868-.352 1.21 1.21 0 0 1 .856.352 1.21 1.21 0 0 1 .352.856c0 .17-.032.33-.096.476a1.158 1.158 0 0 1-.64.632 1.23 1.23 0 0 1-.472.092 1.251 1.251 0 0 1-.868-.344 1.137 1.137 0 0 1-.256-.38 1.221 1.221 0 0 1-.092-.476z",
    fill: "#FFF"
  }))));
};

export default SvgQuestionBadge;